import Smartphones from 'Articles/views/ArticlesView/containers/Smartphones'
import Tablets from 'Articles/views/ArticlesView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const ArticlesView = getCurrentDeviceView(Smartphones, Tablets)

export default ArticlesView
